import React from "react";
import { useTheme } from "styled-components";

export const WarningTriangleSvg = (props) => {
  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "14"} height={height ?? "14"} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clipRule="evenodd" d="M8.73408 1.711L13.8222 10.5416C13.9342 10.8052 13.9832 11.0195 13.9972 11.2422C14.0252 11.7624 13.8432 12.268 13.4863 12.6572C13.1293 13.0449 12.6464 13.2738 12.1215 13.3015H1.87523C1.65827 13.2884 1.44131 13.2391 1.23834 13.1628C0.223511 12.7536 -0.266406 11.6021 0.146524 10.604L5.26966 1.70476C5.44463 1.39193 5.71059 1.12211 6.03953 0.948704C6.99137 0.420852 8.20217 0.767667 8.73408 1.711ZM7.60565 7.52997C7.60565 7.86291 7.3327 8.14105 6.99676 8.14105C6.66081 8.14105 6.38086 7.86291 6.38086 7.52997V5.56769C6.38086 5.23406 6.66081 4.96423 6.99676 4.96423C7.3327 4.96423 7.60565 5.23406 7.60565 5.56769V7.52997ZM6.99676 10.5134C6.66081 10.5134 6.38086 10.2353 6.38086 9.90305C6.38086 9.56942 6.66081 9.29197 6.99676 9.29197C7.3327 9.29197 7.60565 9.56318 7.60565 9.89542C7.60565 10.2353 7.3327 10.5134 6.99676 10.5134Z" fill={window?.settings?.primary_color ?? '#1DBD6B'} />
    </svg>

  )
}